import { FC, ReactNode } from "react";
import Container from "@/components/Container";
import { Button } from "@/components/UI/Buttons/Button";
import { Icons } from "@/assets";

interface ButtonConfig {
  label: string;
  onClick: () => void;
  variant?: "default" | "secondary";
}

interface SuccessPageProps {
  title: string;
  buttons?: ButtonConfig[];
  children?: ReactNode;
}

const SuccessPage: FC<SuccessPageProps> = ({ title, buttons, children }) => {
  return (
    <Container>
      <div className="min-h-screen flex flex-col items-center justify-center px-4 pb-20">
        <div className="max-w-[600px] w-full text-center space-y-6">
          <div className="flex justify-center mb-8">
            <div className="w-24 h-24 rounded-full bg-secondary/10 flex items-center justify-center">
              <Icons.Checkmark className="w-12 h-12 text-secondary" />
            </div>
          </div>

          <h1 className="text-primary text-3xl md:text-4xl font-bold">
            {title}
          </h1>

          {children}

          {buttons && buttons.length > 0 && (
            <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
              {buttons.map((button, index) => (
                <Button
                  key={index}
                  onClick={button.onClick}
                  variant={button.variant || "default"}
                  className="px-8 py-3"
                >
                  {button.label}
                </Button>
              ))}
            </div>
          )}
        </div>
      </div>
    </Container>
  );
};

export default SuccessPage;
